<template>
  <div class="app-container-v2 process-content-container">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">工资条发放</span>
      </div>
    </div>

    <div class="flex vertical p24 table-body" v-loading="loading">
      <air-table
          v-if="render"
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      >
        <template #isSendEmail="{ row }">
          <div v-if="row.isSendEmail === '10020001'" class="flex center mt4">
            <span class="font-12">已发送</span>
            <img src="@/assets/img/v2/service-process/查看.png" class="size14 ml8 pointer" @click="showPreviewEmail(row)"/>
          </div>
          <span v-else class="font-12">-</span>
        </template>
        <template #isSendWeChat="{ row }">
          <div v-if="row.isSendWeChat === '10020001'" class="flex center mt4">
            <span class="font-12">已发送</span>
            <img src="@/assets/img/v2/service-process/查看.png" class="size14 ml8 pointer" @click="showPreviewWechat(row)"/>
          </div>
          <span v-else class="font-12">-</span>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <el-dialog class="modal-v2" title="邮件工资条预览" :visible.sync="previewEmailShow" :close-on-click-modal="false" width="889px" append-to-body v-dialog-drag>
      <div class="flex center p20">
        <preview-email :data="emailData"></preview-email>
      </div>
      <div slot="footer" class="w100 flex jend acenter">
        <el-button type="primary" class="button-v2" @click="previewEmailShow = false">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
        class="drawer-v2"
        title="微信工资条预览"
        :visible.sync="previewWechatShow"
        :wrapper-closable="false"
        size="600px"
    >
      <div class="air-drawer-container">
        <div class="air-drawer-body grid center">
          <preview-wechat :data="wechatData"></preview-wechat>
        </div>
        <div class="air-drawer-footer flex jend acenter">
          <el-button type="primary" class="button-v2" @click="previewWechatShow = false">确定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import previewEmail from './preview-email'
import previewWechat from './preview-wechat'
import * as api from '@/api/v2/service-process/order'

export default {
  components: { previewEmail, previewWechat },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      render: false,
      loading: false,
      queryParams: {
        page: 1,
        limit: 10,
      },
      total: 0,
      columns: [],
      tableData: [],
      dictMap: {},
      previewEmailShow: false,
      emailData: {},
      previewWechatShow: false,
      wechatData: {}
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.orderId = this.data.orderInfo.id
      this.getData()
    },
    getData() {
      this.loading = true
      api.getBizSalaryPayrollByPage(this.queryParams).then(res => {
        const data = res.data.data
        if (!this.dictMap.taxType) {
          this.dictMap.taxType = this.$arrayToObj(data.codeSets['2004'], 'codeItemId')
        }
        this.columns = this.handleColumns(data.wageItems)
        this.tableData = this.$handleTableDict(data.data, this.dictMap)
        this.total = data.params.total
        this.loading = false
        this.render = true
      })
    },
    handleColumns(wageItems) {
      let columns = [
        {title: '员工姓名', field: 'empName', fixed: 'left', minWidth: 100, filterType: 'input'},
        {title: '证件号码', field: 'identityNum', fixed: 'left', minWidth: 120, filterType: 'input'}
      ]
      for (let item of wageItems) {
        if (item.setName === '员工信息') continue
        columns.push({
          title: item.itemName,
          field: this.$changeCase.camelCase(item.columnCode),
          money: true,
          minWidth: 100
        })
      }
      columns.push({title: '邮件工资条', field: 'isSendEmail', custom: true, fixed: 'right', minWidth: 100})
      columns.push({title: '微信工资条', field: 'isSendWeChat', custom: true, fixed: 'right', minWidth: 100})
      return columns
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    showPreviewEmail(row) {
      this.$go_blank('/biz/salarySheetView', {
        salaryDetailId:row.salaryDetailId
      })
    },
    showPreviewWechat(row) {
      api.previewpayslipphone({
        month: row.wageMonth,
        empId: row.empId,
        detailId: row.salaryDetailId
      }).then(res => {
        if (res.data.code === 0) {
          for (const group of res.data.data.dataList) {
            for (const item of group.itemList) {
              if (item.name.includes('实发')) {
                this.wechatData.netPay = item.money
                break
              }
            }
          }
          this.wechatData.wageMonth = row.wageMonth
          this.wechatData.list = res.data.data.dataList
          this.previewWechatShow = true
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.order-info-container {
  .order-info-box:last-child {
    margin-bottom: 40px;
  }
}
.title-block {
  width: 4px;
  height: 14px;
  background: #0093AB;
  border-radius: 2px;
}
.file-list-container {
  background: #F8F9FA;
  border-radius: 4px;
  padding: 30px 20px;

  .file-box:last-child {
    margin-bottom: 0;
  }
}
</style>
